import { render, staticRenderFns } from "./admin_tag_single_select.vue?vue&type=template&id=0039159f"
import script from "./admin_tag_single_select.vue?vue&type=script&lang=js"
export * from "./admin_tag_single_select.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./admin_tag_single_select.vue?vue&type=style&index=1&id=0039159f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports